var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"rotulo d-inline-block p-1 m-1",class:_vm.corRotulo},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.rotulo))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }